import { render } from "./OtpConfirmation.vue?vue&type=template&id=54db8c33"
import script from "./OtpConfirmation.vue?vue&type=script&lang=js"
export * from "./OtpConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__